'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pagerOffsetChange = pagerOffsetChange;
exports.pagerUpdate = pagerUpdate;
var PAGER_OFFSET_CHANGE = exports.PAGER_OFFSET_CHANGE = 'PAGER_OFFSET_CHANGE';
var PAGER_UPDATE = exports.PAGER_UPDATE = 'PAGER_UPDATE';

function pagerOffsetChange(stateKey, offset, pagerLength) {
    return {
        type: PAGER_OFFSET_CHANGE,
        offset: offset,
        pagerLength: pagerLength,
        stateKey: stateKey
    };
}

function pagerUpdate(stateKey, pagination, pagerLength) {
    return {
        type: PAGER_UPDATE,
        pagination: pagination,
        pagerLength: pagerLength,
        stateKey: stateKey
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-pagination/lib/actions/index.js
// module id = 397
// module chunks = 1